import Image from 'next/image';
import { Reveal } from '@netfront/ui-library';

export const PhaseReveals = () => {
  return (
    <>
      <Reveal
        backgroundColor=""
        borderColor=""
        eventDirection=""
        iconUrl=""
        style={'TEXT_AND_ICON'}
        titleColor=""
        eventTitle="Who?"
        triggerStyle="PLUS"
      >
        <div className="flex flex-col md:flex-row gap-4 items-start">
          <Image
            alt="Healthy eating"
            className="rounded-lg align-self-center object-cover"
            height={200}
            src="/phase-reveals/healthy-eating.jpg"
            width={200}
          />
          <div>
            <h3 className="h5 mb-2 text-uppercase">Eligible participants will be:</h3>
            <p>
              Parents and Year 7 students at participating public schools across NSW. Schools will be randomised to one of two groups:
              intervention or control.
            </p>
          </div>
        </div>
      </Reveal>

      <Reveal
        backgroundColor=""
        borderColor=""
        eventDirection=""
        iconUrl=""
        style={'TEXT_AND_ICON'}
        titleColor=""
        eventTitle="When?"
        triggerStyle="PLUS"
      >
        <div className="flex flex-col md:flex-row gap-4 items-start">
          <Image
            alt="Smoking and vaping"
            className="rounded-lg align-self-center object-cover"
            height={200}
            src="/phase-reveals/smoking-and-vaping.jpg"
            width={200}
          />
          <div>
            <h3 className="h5 mb-2 mb-2 text-uppercase">July 2026 - December 2027</h3>
            <p>Students and parents will complete the program (and/or surveys) in Term 3 or 4 2026, and two follow-up surveys over 12 months.</p>
          </div>
        </div>
      </Reveal>

      <Reveal
        backgroundColor=""
        borderColor=""
        eventDirection=""
        iconUrl=""
        style={'TEXT_AND_ICON'}
        titleColor=""
        eventTitle="What?"
        triggerStyle="PLUS"
      >
        <div className="flex flex-col md:flex-row gap-4 items-start">
          <Image
            alt="Screen time and social media"
            className="rounded-lg align-self-center object-cover"
            height={200}
            src="/phase-reveals/screen-time-and-social-media.jpg"
            width={200}
          />
          <div>
            <h3 className="h5 mb-2 text-uppercase">School-based trial</h3>
            <p>
              <strong>Intervention Group:</strong> Parents will complete the brief, interactive <span className="h-italic">Health4Life Parents & Teens</span> program online at home (1 parent per student). Year 7 students will complete the <span className="h-italic">Health4Life</span> school-based program during PDHPE class over 6 weeks. Parents and teens complete three opt-in online surveys over 12 months.
            </p>
            <br />
            <p>
              <strong>Control group:</strong> Students will complete their usual PDHPE classes. Parents and teens complete three opt-in online surveys over 12 months.
            </p>
            <br />
            <p>
              <strong>Format:</strong> Online
            </p>
            <br />
            <p>
              <strong>Reimbursement:</strong> Schools that participate are reimbursed up to $750 over 12 months. Parents who start the online program and complete surveys enter the draw to win 1 of 10 $100 e-gift cards (per school, per survey).
            </p>
          </div>
        </div>
      </Reveal>
      <Reveal
        backgroundColor=""
        borderColor=""
        eventDirection=""
        iconUrl=""
        style={'TEXT_AND_ICON'}
        titleColor=""
        eventTitle="About our Program"
        triggerStyle="PLUS"
      >
        <div className="flex flex-col md:flex-row gap-4 items-start">
          <div className="flex align-self-center flex-col gap-4 shrink-0 ">
            <Image
              alt="About our program"
              className="rounded-lg object-contain"
              height={200}
              src="/phase-reveals/about-our-program.png"
              width={200}
            />
            <Image
              alt="Cartoon example"
              className="rounded-lg object-cover"
              height={200}
              src="/phase-reveals/cartoon-example.png"
              width={200}
            />
          </div>
          <div>
            <p>Health4Life Parents and Teens is a brief online program, that aims to improve the <strong>'Big 6'</strong> health risk behaviours among teens. The 'Big 6' are: excessive recreational screentime, physical inactivity, poor quality diet and sleep, and using alcohol and cigarettes/vapes.</p>
            <br />
            <p>In recent years, we have worked with teachers, teens and parents to design an <strong>engaging online program</strong> to improve the 'Big 6' among Australian teens, with the support of their parents.</p>
            <br />
            <p>The <strong>school-based Health4Life program is PDHPE curriculum aligned. Teachers will deliver</strong> 6 online, cartoon-storyline modules to educate teens about the 'Big 6' (trialed in over 71 schools to date). The accompanying parent program also uses brief, engaging online (at-home) modules, to improve parents' knowledge and skills around parenting the 'Big 6'.</p>
            <br />
            <p>This short video (which is from the prior phase of our trial), provides an example of the parent-based program: <a href="https://vimeo.com/1048465962?share=copy&fl=sv&fe=ci" target="_blank" rel="noopener noreferrer">https://vimeo.com/1048465962?share=copy&fl=sv&fe=ci</a></p>
            <br />
            <p><strong>To learn more about this school-based program and trial, express interest today.</strong></p>
          </div>
        </div>
      </Reveal>
    </>
  );
};
